import {
	Button,
	Pagination,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { developAxios } from "../../axios.config";

interface ISelectedDashboardState {
	_id: string;
	name: string;
}

interface IDashboardList {
	value?: ISelectedDashboardState | null | undefined;
	onChange?: (val: ISelectedDashboardState) => unknown;
}

type TDashboardData = {
	_id: string;
	name: string;
	dateAdded: string;
};

function DashboardList(props: IDashboardList) {
	const { onChange, value } = props;

	const [page, setPage] = useState(1);

	const {
		data: dashboards,
		isLoading,
		refetch,
	} = useQuery(["superadmin", "get-course"], () => {
		return developAxios(localStorage.getItem("token") || "")
			.get<{
				data: {
					courses: TDashboardData[];
					page_number: number;
					total_pages: number;
				};
			}>("/superadmin/course", { params: { page, limit: 20 } })
			.then(({ data }) => data.data);
	});

	useEffect(() => {
		refetch();
	}, [page, refetch]);

	return (
		<div>
			{!isLoading && dashboards && (
				<TableContainer component={Paper}>
					<Table sx={{ width: "100%" }}>
						<TableHead>
							<TableRow>
								<TableCell>Name</TableCell>
								<TableCell>Date Added</TableCell>
								<TableCell>Actions</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{dashboards &&
								dashboards.courses.map((dashboard) => (
									<TableRow key={dashboard._id}>
										<TableCell>{dashboard.name}</TableCell>
										<TableCell>
											{dashboard.dateAdded}
										</TableCell>
										<TableCell>
											<Button
												variant={"contained"}
												onClick={() =>
													onChange &&
													onChange({
														_id: dashboard._id,
														name: dashboard.name,
													})
												}
												color={
													dashboard._id === value?._id
														? "success"
														: "primary"
												}
											>
												{dashboard._id === value?._id
													? "Selected"
													: "Select"}
											</Button>
										</TableCell>
									</TableRow>
								))}
						</TableBody>
					</Table>
				</TableContainer>
			)}
			<Pagination
				page={page}
				count={10}
				color="primary"
				onChange={(_e, value: number) => setPage(value)}
			/>
		</div>
	);
}

export default DashboardList;
